import { memo, useEffect, useState } from "react";
import styled from "styled-components";
import OrganizationItem from "./OrganizationItem";
import { Organization_Base } from "~/common/typescript/models/Organization";
import { AC_Organization_Base, AC_Organization_Role } from "~/common/typescript/services/access_control/AC_Organization";
import { OrganizationAPIs } from "~/common/typescript/apis/OrganizationAPIs";

const ListSharedOrg = () => {
  const [organizations, setOrganizations] = useState<AC_Organization_Base[]>([]);
  const fetchData = () => {
    OrganizationAPIs.remote_getSharedOrg().then((data) => {
      // data is AC_Organization_Base[] with .organization field
      setOrganizations(data || []);
    });
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <UI_Wrapper>
      <UI_Header>
        <UI_TitleRow>
          <UI_Title>Được chia sẻ với tôi</UI_Title>
          {organizations?.length > 0 && <UI_Badge>{organizations.length}</UI_Badge>}
        </UI_TitleRow>
      </UI_Header>

      <UI_List>
        {organizations?.map((acOrg) => (
          acOrg.organization && (
            <OrganizationItem
              key={acOrg.organization.id}
              organization={acOrg.organization as Organization_Base}
              role={acOrg.role as AC_Organization_Role}
            />
          )
        ))}
        {organizations?.length === 0 && (
          <UI_Empty>Không có doanh nghiệp nào được chia sẻ với bạn</UI_Empty>
        )}
      </UI_List>
    </UI_Wrapper>
  );
};

export default memo(ListSharedOrg);

const UI_Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #f1f5f9;
`;

const UI_Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const UI_TitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const UI_Title = styled.h2`
  font-size: 16px;
  font-weight: 600;
  color: #1e293b;
  margin: 0;
`;

const UI_Badge = styled.span`
  background: #f1f5f9;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 12px;
  border: 1px solid #e2e8f0;
`;

const UI_List = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 10px;
`

const UI_Empty = styled.div`
  padding: 20px;
  text-align: center;
  color: #999;
  font-size: 14px;
`
